import { BaseEndpoint } from "./BaseEndpoint";

export class Endpoint extends BaseEndpoint("claims") {
  getAll(): Promise<string[]> {
    return this.request();
  }
}

export const ClaimEndpoint = Endpoint;
